<template>
  <div v-if="show" class="su-mask" @click.self="maskClick">
    <div class="zjs-advert" :style="{ width: config.width }">
      <slot v-if="$slots.content" name="content"> </slot>
      <a
        v-else
        id="adModel_link"
        :href="config.link"
        :class="{ outerAd: config.ad }"
        @click="aClick"
      >
        <img :src="config.img" />
        <div
          v-for="(item, index) in config.hotspot"
          :key="index"
          class="adModel-hotsopt"
          :data-hotspot="index"
          :style="{
            left: item.left + '%',
            right: item.right + '%',
            top: item.top + '%',
            bottom: item.bottom + '%'
          }"
        ></div>
      </a>
      <div class="zjs-advert-close" @click.stop="close">
        <div>
          <img
            id="admodel-close"
            src="https://img.yzcdn.cn/upload_files/2019/11/25/Fs53hUSGrw074xduGjRxvDIQSTYd.png"
            alt
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AdModel',
  props: {
    options: {
      type: Object,
      default: () => ({
        img: '',
        link: 'javascript:void(0)',
        ad: false,
        width: '70%',
        click: () => false,
        close: () => false,
        clickOverlay: true,
        hotspot: []
      })
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    config() {
      const defaultOptions = {
        img: '',
        link: 'javascript:void(0)',
        ad: false,
        width: '70%',
        click: () => false,
        close: () => false,
        clickOverlay: true,
        hotspot: []
      }
      return { ...defaultOptions, ...this.options }
    }
  },
  methods: {
    aClick(e) {
      const { hotspot, click } = this.config
      if (e.target.dataset.hotspot && e.target.className.indexOf('adModel-hotsopt') > -1) {
        hotspot[e.target.dataset.hotspot].click &&
          hotspot[e.target.dataset.hotspot].click(this.close)
      } else {
        click(this.close)
      }
      e.stopPropagation()
    },
    maskClick(e) {
      const { clickOverlay } = this.config
      if (clickOverlay) {
        this.close()
      }
      e.stopPropagation()
    },
    close() {
      const { close } = this.config
      this.$emit('update:show', false)
      this.$emit('onClose')
      close()
    }
  }
}
</script>
<style lang="scss">
@import './admodel.scss';
</style>
